export default {
  'digitalSignatureFieldMapping.title': 'Digital Signature Field Mapping',

  'digitalSignatureFieldMapping.form.form': 'Form',
  'digitalSignatureFieldMapping.form.field': 'Field',
  'digitalSignatureFieldMapping.form.isShowDigitalSignatureStampEnabled':
    'Show Digital Signature Stamp?',
  'digitalSignatureFieldMapping.form.signaturePosition': 'Digital Signature Stamp Position',
  'digitalSignatureFieldMapping.form.pageToPlaceDigitalStamp':
    'Page To Place Digital Signature Stamp',

  'digitalSignatureFieldMapping.form.select.TopStart': 'Top - Start',
  'digitalSignatureFieldMapping.form.select.TopMiddle': 'Top - Middle',
  'digitalSignatureFieldMapping.form.select.TopEnd': 'Top - End',

  'digitalSignatureFieldMapping.form.select.CenterStart': 'Middle - Start',
  'digitalSignatureFieldMapping.form.select.CenterMiddle': 'Middle - Middle',
  'digitalSignatureFieldMapping.form.select.CenterEnd': 'Middle - End',

  'digitalSignatureFieldMapping.form.select.BottomStart': 'Bottom - Start',
  'digitalSignatureFieldMapping.form.select.BottomMiddle': 'Bottom - Middle',
  'digitalSignatureFieldMapping.form.select.BottomEnd': 'Bottom - End',
};
